import axiosClient from "./axiosClient.js";
import ROUTES from "./api_routes.js";

async function search(search_term) {
  const params = {};
  if (search_term) {
    params.search_term = search_term;
  }
  return axiosClient.get(ROUTES.GET_SEARCH, { params });
}

const SearchClient = {
  search
};

export default SearchClient; 